import { render, staticRenderFns } from "./assignment-editor.vue?vue&type=template&id=b9c9d894&"
import script from "./assignment-editor.vue?vue&type=script&lang=ts&"
export * from "./assignment-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports